<div tabindex="0" autofocus style="outline: none" class="row" *ngIf="sub"> <!--Fixme P5W-3337&P5W-3339: Aktuell workaround, alles andere funktioniert nicht :(-->
  <div class="col-12">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('subscription_header')" [innerHTML]="translationService.getTranslation('subscription_header')"></h3>
  </div>
  <div class="col-12">
    <h4 [innerHTML]="translationService.getTranslation('subscription_intro')"></h4>
  </div>
  <div class="col-12" *ngIf="sub.state === 3"
       [innerHTML]="translationService.getTranslation('subscription_canceled')">
  </div>
  <mat-card class="mt-2">
    <mat-card-content>
      <div class="form-group col-12">
        <div class="row">
          <div *ngIf="sub.userBackendId >= 0" class="col-12 col-sm-6"
               [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + sub.userBackendId">
          </div>
          <div *ngIf="sub.userBackendId < 0" class="col-12 col-sm-6"
               [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + translationService.getTranslation('subscription_user_not_assigned')">
          </div>
        </div>
      </div>
      <div class="form-group col-12">
        <div class="row">
          <div *ngIf="userData && userData.emailList?.length > 0" class="col-12 col-sm-6"
               [innerHTML]="translationService.getTranslation('label_email') + ': ' + userData.emailList[0]">
          </div>
        </div>
      </div>
      <h5 class="mt-5" *appApplyIfNotEmpty="translationService.getTranslation('label_subscriptionDetails')"
          [innerHTML]="translationService.getTranslation('label_subscriptionDetails')"></h5>
      <div class="form-group col-12">
        <div class="row">
          <div class="col-12 col-sm-6" *ngIf="sub.backendId > 0"
               [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.backendId">
          </div>
          <div class="col-12 col-sm-6" *ngIf="sub.backendId <= 0"
               [innerHTML]="translationService.getTranslation('order_id') + ': ' + translationService.getTranslation('no_order_id')">
          </div>
        </div>
      </div>

      <ng-container *ngIf="showAdditionalSubscriptionInfos">
        <ng-container *ngIf="{
          ADR_BILLING: adrBilling,
          ADR_DELIVERY: adrDelivery,
          CONTRACT_CURRENT: contractCurrent,
          CONTRACT_FUTURE: contractFuture,
          PAYMENT: payment
        } as templates">
          <ng-container *ngFor="let key of blockOrder">
            <ng-container *ngTemplateOutlet="templates[key]" ></ng-container>
          </ng-container>
        </ng-container>

        <ng-template #payment>
          <ng-container *ngIf="sub.curPayment">
            <h5 class="d-inline-block mt-5" *appApplyIfNotEmpty="translationService.getTranslation('navi_bankchange')"
                [innerHTML]="translationService.getTranslation('navi_bankchange')"></h5>&nbsp;
            <a [routerLink]="'/payment'"
               [attr.aria-label]="translationService.getTranslation('navi_bankchange') + ' ' + translationService.getTranslation('button_edit')"
            ><mat-icon fontIcon="edit"/></a>

            <div class="form-group col-12">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div [innerHTML]="translationService.getTranslation('payment_type') + ': ' + paymentMethodDesc"></div>
                </div>
              </div>
            </div>
            <div class="form-group col-12">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div
                    [innerHTML]="translationService.getTranslation('payment_rhythm') + ': ' + sub.curPayment.paymentType.paymentFrequency"></div>
                </div>
              </div>
            </div>
              <ng-container *ngIf="paymentMethodId && paymentMethodId.paymentType === 'DIRECTDEBITIBAN'">
                <div class="form-group col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div
                        [innerHTML]="translationService.getTranslation('payment_iban') + ': ' + sub?.curPayment?.bank?.swiftIBAN | bankAccount"></div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div
                        [innerHTML]="translationService.getTranslation('payment_bic') + ': ' + sub?.curPayment?.bank?.swiftBIC"></div>
                    </div>
                  </div>
                </div>
              </ng-container>
          </ng-container>
        </ng-template>

        <ng-template #contractCurrent>
          <ng-container *ngIf="sub.combiSubscriptionList && sub.combiSubscriptionList.length > 0 && !currentAndSequelSubscriptionsAreSimilar()">
            <div>
              <ng-container>
                <h5 class="mt-5"
                    *appApplyIfNotEmpty="translationService.getTranslation('subscription_aggregate_combinations')"
                    [innerHTML]="translationService.getTranslation('subscription_aggregate_combinations')"></h5>
              </ng-container>
              <app-product-variant-period-block [subscription]="sub"></app-product-variant-period-block>
              <div *ngFor="let comb of sub.combiSubscriptionList">
                <app-product-variant-period-block [subscription]="comb"></app-product-variant-period-block>
              </div>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #contractFuture>
          <ng-container *ngIf="sub.sequelSubscriptions && sub.sequelSubscriptions.length > 0 && showSequelSubscriptionInAggregateMode">
            <ng-container *ngIf="sub.sequelSubscriptions && sub.sequelSubscriptions.length > 0">
              <h5 class="mt-5" *appApplyIfNotEmpty="translationService.getTranslation('subscription_aggregate_sequels')"
                  [innerHTML]="translationService.getTranslation('subscription_aggregate_sequels')"></h5>
            </ng-container>
            <ng-container *ngFor="let sequel of sub.sequelSubscriptions">
              <app-product-variant-period-block [subscription]="sequel"></app-product-variant-period-block>
              <div *ngFor="let sequelComb of sequel.combiSubscriptionList">
                <app-product-variant-period-block [subscription]="sequelComb"></app-product-variant-period-block>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>

        <ng-template #adrDelivery>
          <ng-container *ngIf="sub.curDelivery">
            <h5 class="d-inline-block mt-5" *appApplyIfNotEmpty="translationService.getTranslation('address_delivery')"
                [innerHTML]="translationService.getTranslation('address_delivery')"></h5>&nbsp;
            <a [routerLink]="'/move'" *ngIf="isMoveServiceActive"
               [attr.aria-label]="translationService.getTranslation('address_delivery') + ' ' + translationService.getTranslation('button_edit')"
            ><mat-icon fontIcon="edit"/></a>

            <div class="form-group col-12">
              <app-address-detail [address]="sub.curDelivery.address"
                                  [person]="sub.curDelivery.person"></app-address-detail>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #adrBilling>
          <ng-container *ngIf="sub.curBilling">
            <h5 class="mt-5" [innerHTML]="translationService.getTranslation('address_billing')"></h5>
            <div class="form-group col-12">
              <app-address-detail [address]="sub.curBilling.address"
                                  [person]="sub.curBilling.person"></app-address-detail>
            </div>
          </ng-container>
        </ng-template>

      </ng-container>
    </mat-card-content>

    <ng-container *ngIf="sub.subId > 0 && showTerminationButton">
      <mat-card-actions>
        <div class="form-group col-12 mt-5 mb-2">
          <div class="row">
            <div class="col-12 col-sm-6">
              <button mat-raised-button *ngIf="isTerminatable(sub); else subscriptionTerminated"
                      (click)="terminateSubscription()" [innerHTML]="translationService.getTranslation('button_terminate')">
              </button>
              <ng-template #subscriptionTerminated>
                <div
                  *ngIf="sub.subId > 0 && sub.webId > 0">{{ translationService.getTranslation('subscription_terminated_webabo') }}
                </div>
                <div
                  *ngIf="sub.subId > 0 && sub.webId < 0">{{ translationService.getTranslation('subscription_terminated_paradise') }}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </mat-card-actions>
    </ng-container>
  </mat-card>
</div>

<div class="mt-3 float-end">
  <button *ngIf="showBackToOverviewButton"
          mat-raised-button (click)="backToOverview()"
          [innerHTML]="translationService.getTranslation('button_back_to_overview')"></button>
</div>
